import { render } from "./car_repair_type.vue?vue&type=template&id=3ef922cf"
import script from "./car_repair_type.vue?vue&type=script&lang=js"
export * from "./car_repair_type.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__